
import CardPlaceholder from './ProductThumb/Card/CardPlaceholder.vue'
import ListPlaceholder from './ProductThumb/List/ListPlaceholder.vue'

const NUMBER_OF_RESULTS = 30

export default {
  components: {
    CardPlaceholder,
    ListPlaceholder,
  },
  props: {
    wide: { type: Boolean, default: false },
  },
  computed: {
    NUMBER_OF_RESULTS: () => NUMBER_OF_RESULTS,
  },
}
